import * as React from "react";
import {LoadingViewState, RouterView} from "../RouterView";
import {RouteComponentProps, withRouter} from "react-router";
import {getContainer} from "../../ioc/IOCSetup";
import {MultiBalanceTransaction} from "../../http/protocol";
import {MultiBalanceService} from "../../services/MultiBalanceService";
import {UserLinkPanel} from "../user/UserLinkPanel";
import {formatDate} from "../../util/date";

interface State extends LoadingViewState{
    transactions? : MultiBalanceTransaction[];
}

export class MultiBalanceAccountView extends RouterView<RouteComponentProps,State>{

    multibalanceService : MultiBalanceService;

    constructor(props : RouteComponentProps){
        super(props);
        this.multibalanceService = getContainer().getMultiBalanceService();
        this.state = { };
    }

    getTitle() {
        return "MultiBalance Account";
    }

    loadContent(): Promise<any>  {

        var id = (this.props.match.params as any).id;
        var username = (this.props.match.params as any).username;
        var currencyCode = (this.props.match.params as any).currencyCode;

        return this.multibalanceService.getTransactionList({CustomerID : username, CurrencyCode : currencyCode}).then((response) => {
            this.setState({ transactions : response.transactions || [] });
        })
    }

    formatAmount(amount?: number) {
        if (amount == null) {
            return "";
        }
        return amount.toLocaleString("en",{maximumFractionDigits:8, minimumFractionDigits:2});
    }

    renderContent() {
        var id = (this.props.match.params as any).id;
        return (
            <div>

                <div className="row">
                    <div className="col-lg-6">
                        <UserLinkPanel userId={Number(id)} header="Account Owner" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card-box">
                            <h4>Transactions</h4>
                            <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    <th>Currency</th>
                                    <th>Description</th>
                                    <th>Reference</th>
                                    <th>Balance</th>
                                </tr>
                                </thead>
                                <tbody>
                                {(this.state.transactions || []).map((transaction, index) => (
                                    <tr key={transaction.DocumentNumber != null ? transaction.DocumentNumber : index}>
                                        <td>{formatDate(transaction.TranDateTime)}</td>
                                        <td>{transaction.TranCode == "C" ? "Credit" : "Debit"}</td>
                                        <td>{this.formatAmount(transaction.Amount)}</td>
                                        <td>{transaction.CurrencyCode}</td>
                                        <td>{transaction.Description}</td>
                                        <td>{transaction.Reference}</td>
                                        <td>{this.formatAmount(transaction.CurrencyBalance)}</td>
                                    </tr>
                                ))}
                                {(!this.state.transactions || this.state.transactions.length === 0) && (
                                    <tr><td colSpan={7}>No transactions found</td></tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        );
    }

}
export default withRouter(MultiBalanceAccountView);
